export default __webpack_public_path__ + "static/media/add.d59161e5.svg";